"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lowerCase = _interopRequireDefault(require("lodash/lowerCase"));
var _constant = require("../constant");
var _getRelativeDate = require("./get-relative-date");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getOpportunityEndDate = function getOpportunityEndDate(opportunity) {
  var _relativeDate = (0, _getRelativeDate.relativeDate)(opportunity.end),
    message = _relativeDate.message,
    close = _relativeDate.close;
  if ([_constant.opportunityTypes.JOB, _constant.opportunityTypes.INTERNSHIPS].includes((0, _lowerCase.default)(opportunity.type)) && opportunity.reviewApplications && !close) {
    return {
      label: 'Rolling Review',
      style: {
        fontStyle: 'italic'
      }
    };
  }
  if (opportunity.end) {
    return {
      label: message
    };
  }
  return {
    label: ''
  };
};
var _default = getOpportunityEndDate;
exports.default = _default;